<planone-search-input
  cacheKey="exhibitorDirectory"
  [options]="options$ | async"
  [submittedSearchTerm]="submittedSearchTerm"
  [size]="size"
  [asYouTypeResultWithIcon]="true"
  [hasIconOnlyWithOverlayMobileTemplate]="true"
  [placeholderText]="placeholderText"
  [sidebarOverlayToggled]="searchPageFacade.overlayToggled$ | async"
  (searchFieldChanged)="searchSuggestions($event)"
  (searchFieldSubmitted)="searchSubmitted($event)"></planone-search-input>
